import { useRouter } from 'vue-router';
import { computed, ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c201e272"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "维度：", -1));
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "scores_title"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 2
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 3
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 4
};
import { exportBillList, getBillList } from '@/api/thirdParty';
import { awaitWrap, getNode, OK } from '@/common';
import { message } from 'ant-design-vue';
import { usePagination } from '@/hooks/usePagination';
import { useTimer } from '@/views/thirdPartyBill/hooks/useTimer';
import BillModal from './BillModal.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdPartyContent',
  setup(__props, {
    expose
  }) {
    const {
      timer,
      getExportFile
    } = useTimer();
    const router = useRouter();
    const dimensionOptions = [{
      label: '支付渠道',
      value: 'pay_chnl',
      title: 'payChnlName'
    }];
    const basicColumns = [{
      title: '时间',
      dataIndex: 'dateTime',
      key: 'dateTime'
    }, {
      title: '产品名',
      dataIndex: 'appName',
      key: 'appName'
    }, {
      title: '支付渠道',
      dataIndex: 'payChnlName',
      key: 'payChnlName'
    }, {
      title: '销售额',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '服务费',
      dataIndex: 'commissionAmount',
      key: 'commissionAmount'
    }, {
      title: '税费',
      dataIndex: 'tax',
      key: 'tax'
    }, {
      title: '退款金额',
      dataIndex: 'refundAmount',
      key: 'refundAmountC'
    }, {
      title: '收入',
      dataIndex: 'revenue',
      key: 'revenue'
    }, {
      title: '币种',
      dataIndex: 'currency',
      key: 'currency'
    }, {
      title: '付款订单数',
      dataIndex: 'orderAmount',
      key: 'orderAmount'
    }, {
      title: '退款订单数',
      dataIndex: 'refundOrderAmount',
      key: 'refundOrderAmount'
    }];
    const monthBillExtraColumnDefs = [{
      title: '税前收入',
      dataIndex: 'preTaxRevenue',
      key: 'preTaxRevenue'
    }, {
      title: '支付统计',
      dataIndex: 'payStatTotal',
      key: 'payStatTotal'
    }, {
      title: '误差',
      dataIndex: 'errorRate',
      key: 'errorRate'
    }];
    const isIos = computed(() => string => {
      return string.toLowerCase().indexOf('ios') !== -1;
    });
    const dataSource = ref([]);
    const columns = ref(basicColumns);
    const dimensionList = ref([]);
    const dimensionTitleList = ref([]);
    const indexList = ref([]);
    const searchForm = ref({});
    const loading = ref(false);
    const activeKey = ref('1');
    const modelVisible = ref(false);
    const openModel = () => {
      modelVisible.value = true;
    };
    const getData = async (searchObj = {}) => {
      var _Object$keys;
      if ((_Object$keys = Object.keys(searchObj)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
        searchForm.value = searchObj;
      }
      let params = {
        pageNum: pageIndex.value,
        pageSize: pageSize.value,
        dimensionList: dimensionList.value
      };
      Object.keys(searchForm.value).forEach(item => {
        var _searchForm$value$ite;
        if (searchForm.value[item] && (_searchForm$value$ite = searchForm.value[item]) !== null && _searchForm$value$ite !== void 0 && _searchForm$value$ite.length) {
          params = {
            ...params,
            [item]: searchForm.value[item]
          };
        }
      });
      loading.value = true;
      const [err, data] = await awaitWrap(getBillList(params));
      if (data && data.code === OK) {
        var _data$data, _data$data2;
        dataSource.value = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.list;
        pageTotal.value = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.total;
      }
      if (err) {}
      loading.value = false;
    };
    const searchData = (searchObj = {}) => {
      pageIndex.value = 1;
      getData(searchObj);
    };
    const exportExcel = async () => {
      var _dataSource$value, _columns$value;
      if (!((_dataSource$value = dataSource.value) !== null && _dataSource$value !== void 0 && _dataSource$value.length)) return false;
      let params = {
        dimensionList: dimensionList.value,
        indicatorList: (_columns$value = columns.value) === null || _columns$value === void 0 ? void 0 : _columns$value.map(i => i.dataIndex)
      };
      Object.keys(searchForm.value).forEach(item => {
        var _searchForm$value$ite2;
        if (searchForm.value[item] && (_searchForm$value$ite2 = searchForm.value[item]) !== null && _searchForm$value$ite2 !== void 0 && _searchForm$value$ite2.length) {
          params = {
            ...params,
            [item]: searchForm.value[item]
          };
        }
      });
      const [err, data] = await awaitWrap(exportBillList(params));
      if (data && data.code === OK) {
        if (timer.value) return message.error('导出中，请稍后');
        timer.value = setInterval(() => {
          var _data$data3;
          getExportFile((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.taskId);
        }, 1000);
      }
      if (err) {}
    };
    const changeDime = () => {
      const titles = [];
      dimensionOptions === null || dimensionOptions === void 0 || dimensionOptions.forEach(i => {
        var _dimensionList$value;
        if ((_dimensionList$value = dimensionList.value) !== null && _dimensionList$value !== void 0 && _dimensionList$value.includes(i.value)) {
          titles.push(i.title);
        }
      });
      dimensionTitleList.value = titles;
      pageIndex.value = 1;
      changeColumns();
      getData();
    };
    const changeColumns = () => {
      const arr = ['dateTime', 'appName', 'amount', 'commissionAmount', 'tax', 'refundAmount', 'revenue', 'currency', 'orderAmount', 'refundOrderAmount', ...dimensionTitleList.value, ...indexList.value];
      columns.value = basicColumns.filter(item => arr.includes(item.dataIndex));
      if (activeKey.value === '2') {
        const i = columns.value.findIndex(c => c.dataIndex === 'revenue');
        if (i !== -1) {
          columns.value = [...columns.value.slice(0, i + 1), ...monthBillExtraColumnDefs, ...columns.value.slice(i + 1)];
        }
        columns.value = [...columns.value, {
          title: '是否可结算',
          dataIndex: 'billStatus',
          key: 'billStatus'
        }];
      }
    };
    const toDetail = (item, type) => {
      if (isIos.value(item.appName)) return;
      let queryObj = {
        dbtId: item.dbtId,
        payChnl: item.payChnl,
        payChnls: searchForm.value.payChnls,
        billType: item.billType,
        datePeriod: searchForm.value.datePeriod,
        startDate: searchForm.value.startDate,
        currency: item.currency,
        type
      };
      if (searchForm.value.datePeriod !== 'sum') {
        queryObj = {
          ...queryObj,
          dateTime: item.dateTime
        };
      }
      if (searchForm.value.endDate) {
        queryObj = {
          ...queryObj,
          endDate: searchForm.value.endDate
        };
      }
      router.push({
        name: 'thirdPartyBillDetail',
        query: queryObj
      });
    };
    const resetDimension = key => {
      activeKey.value = key;
      dimensionList.value = [];
      const titles = [];
      dimensionOptions === null || dimensionOptions === void 0 || dimensionOptions.forEach(i => {
        var _dimensionList$value2;
        if ((_dimensionList$value2 = dimensionList.value) !== null && _dimensionList$value2 !== void 0 && _dimensionList$value2.includes(i.value)) {
          titles.push(i.title);
        }
      });
      dimensionTitleList.value = titles;
      pageIndex.value = 1;
      changeColumns();
    };
    const {
      pageIndex,
      pageSize,
      pageTotal,
      currentPageSizeChange
    } = usePagination(getData);
    const getSettlementText = status => {
      const statusMap = {
        0: '待确认',
        10: '不可结算',
        20: '可结算'
      };
      return status !== undefined ? statusMap[status] || '-' : '-';
    };
    const getSettlementColor = status => {
      const colorMap = {
        0: 'warning',
        10: 'error',
        20: 'success'
      };
      return status !== undefined ? colorMap[status] || 'default' : 'default';
    };
    onMounted(() => {
      changeColumns();
    });
    expose({
      searchData,
      resetDimension
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_select, {
        placeholder: "选择维度",
        options: dimensionOptions,
        value: dimensionList.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => dimensionList.value = $event),
        mode: "multiple",
        "max-tag-count": 2,
        onChange: changeDime,
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"])]), _createElementVNode("div", _hoisted_5, [searchForm.value.billType == 'month' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "export-btn",
        onClick: openModel
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "download",
          "class-name": "mark-icon"
        }), _createTextVNode(" 导入账单 ")]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_a_button, {
        type: "primary",
        class: "export-btn",
        onClick: exportExcel,
        loading: !!_unref(timer)
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      }, 8, ["loading"])])]), _createVNode(_component_a_table, {
        columns: columns.value,
        "data-source": dataSource.value,
        bordered: "",
        scroll: {
          x: 150 * columns.value.length
        },
        pagination: false,
        loading: loading.value
      }, {
        headerCell: _withCtx(({
          title,
          column
        }) => [column.key === 'tax' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("span", _hoisted_6, _toDisplayString(title), 1), _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [_createTextVNode("仅谷歌渠道税费单独统计")]),
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "questionMark",
            "class-name": "mark-icon"
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true)]),
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _ref;
          return [column.dataIndex === 'firstBuyerRatio' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString((_ref = (record === null || record === void 0 ? void 0 : record.firstBuyerRatio) * 100) === null || _ref === void 0 ? void 0 : _ref.toFixed(2)) + "%", 1)) : _createCommentVNode("", true), column.dataIndex === 'prodName' ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(record !== null && record !== void 0 && record.prodName ? record === null || record === void 0 ? void 0 : record.prodName : record === null || record === void 0 ? void 0 : record.sku), 1)) : _createCommentVNode("", true), column.dataIndex === 'orderAmount' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", {
            class: _normalizeClass({
              'order-amount-link': !_unref(isIos)(record.appName)
            }),
            onClick: $event => toDetail(record, 'order')
          }, _toDisplayString() + " " + _toDisplayString(record[column.dataIndex]), 11, _hoisted_10)])) : _createCommentVNode("", true), column.dataIndex === 'refundOrderAmount' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", {
            class: _normalizeClass({
              'order-amount-link': !_unref(isIos)(record.appName)
            }),
            onClick: $event => toDetail(record, 'refundOrder')
          }, _toDisplayString(record[column.dataIndex]), 11, _hoisted_12)])) : _createCommentVNode("", true), column.dataIndex === 'billStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [record.billStatus === 10 && record.billStatusMsg ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.billStatusMsg), 1)]),
            default: _withCtx(() => [_createVNode(_component_a_tag, {
              color: getSettlementColor(record.billStatus)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(getSettlementText(record.billStatus)), 1)]),
              _: 2
            }, 1032, ["color"])]),
            _: 2
          }, 1024)) : (_openBlock(), _createBlock(_component_a_tag, {
            key: 1,
            color: getSettlementColor(record.billStatus)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(getSettlementText(record.billStatus)), 1)]),
            _: 2
          }, 1032, ["color"]))])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "scroll", "loading"]), _createVNode(_component_a_pagination, {
        total: _unref(pageTotal),
        current: _unref(pageIndex),
        "onUpdate:current": _cache[1] || (_cache[1] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        "show-size-changer": "",
        "page-size": _unref(pageSize),
        "onUpdate:page-size": _cache[2] || (_cache[2] = $event => _isRef(pageSize) ? pageSize.value = $event : null),
        onChange: _unref(currentPageSizeChange)
      }, null, 8, ["total", "current", "page-size", "onChange"]), _createVNode(BillModal, {
        "model-visible": modelVisible.value,
        "onUpdate:model-visible": _cache[3] || (_cache[3] = $event => modelVisible.value = $event)
      }, null, 8, ["model-visible"])]);
    };
  }
});